export type SignupRangePreset = "all" | "today" | "7d" | "30d" | "90d" | "this_month" | "last_month" | "custom";

export const SIGNUP_RANGE_OPTIONS: ReadonlyArray<{ value: SignupRangePreset; label: string }> = [
  { value: "all", label: "All time" },
  { value: "today", label: "Today" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "this_month", label: "This month" },
  { value: "last_month", label: "Last month" },
  { value: "custom", label: "Custom range" },
];

export const isSignupRangePreset = (value: unknown): value is SignupRangePreset =>
  SIGNUP_RANGE_OPTIONS.some((o) => o.value === value);

/** A local calendar day as YYYY-MM-DD. */
export const toDay = (date: Date): string => date.toLocaleDateString("en-CA");

/**
 * The signup days (inclusive, admin's local time) a preset covers; "" means open-ended.
 * Relative presets are resolved against `now`, so a saved link stays "last 7 days".
 */
export const signupRangeDays = (
  preset: SignupRangePreset,
  custom: { from: string; to: string },
  now: Date = new Date()
): { from: string; to: string } => {
  const y = now.getFullYear();
  const m = now.getMonth();
  const d = now.getDate();
  const daysBack = (n: number) => ({ from: toDay(new Date(y, m, d - (n - 1))), to: toDay(now) });
  switch (preset) {
    case "today":
      return daysBack(1);
    case "7d":
      return daysBack(7);
    case "30d":
      return daysBack(30);
    case "90d":
      return daysBack(90);
    case "this_month":
      return { from: toDay(new Date(y, m, 1)), to: toDay(now) };
    case "last_month":
      return { from: toDay(new Date(y, m - 1, 1)), to: toDay(new Date(y, m, 0)) };
    case "custom":
      return custom;
    default:
      return { from: "", to: "" };
  }
};
